import axios from "axios";
import { get, post } from "../../utils/api";
import { ASSESSMENT, ASSESSMENT_URL } from "../../utils/url-builder";
import BaseService from "./base.service";

class AssessmentService extends BaseService {
  constructor() {
    super(ASSESSMENT_URL);
    this.route = "assessment/";
  }

  create(classid, assessmentname, username) {
    return new Promise(async (resolve, reject) => {
      try {
        await this.makePostRequest(this.route + "create", {
          classId: classid,
          name: assessmentname,
          createdBy: username,
        });

        return resolve();
      } catch (error) {
        //reject(error);
        console.log(error);
      }
    });
  }

  fetch(classId) {
    return new Promise(async (resolve, reject) => {
      try {
        let res = await this.makeGetRequest(this.route + "fetch", { classId });
        return resolve(res);
      } catch (error) {
        console.log(error);
      }
    });
  }

  read(assessmentId) {
    return new Promise(async (resolve, reject) => {
      try {
        let res = await this.makeGetRequest(this.route + "read", {
          assessmentId,
        });
        return resolve(res);
      } catch (error) {
        console.log(error);
      }
    });
  }

  isRolledBack(assessmentId) {
    return new Promise(async (resolve, reject) => {
      try {
        let res = await this.makeGetRequest(this.route + "isRolledBack", {
          assessmentId,
        });
        return resolve(res);
      } catch (error) {
        console.log(error);
      }
    });
  }

  isExist = assessmentId => new Promise(async (resolve, reject) => {
    try {
      let result = await this.makeGetRequest(this.route + "isExist", {
        assessmentId
      });
      return resolve(result);
    } catch (error) {
      reject(error);
    }
  });

  isPublished = assessmentId => new Promise(async (resolve, reject) => {
    try {
      let result = await this.makeGetRequest(this.route + "isPublished", {
        assessmentId
      });
      return resolve(result);
    } catch (error) {
      reject(error);
    }
  });
}

const assessmentService = new AssessmentService();
export default assessmentService;
